export default __webpack_public_path__ + "static/psle-slay-screen-6-f7777cfc034ff7871bf56ca3250ad2fc.png";